import { axiosConsumer } from "./axiosConsumer";

export const getSkus = async (
  delivery_date: string,
  dealerId?: string
): Promise<unknown[]> => {
  const page = 1;
  const per_page = 400;
  let url = `api/v1/dealer-skus?page=${page}&per_page=${per_page}&delivery_date=${delivery_date}`;

  if (dealerId) {
    url += `&dealer_id=${dealerId}`;
  }

  const { data } = await axiosConsumer.get(url);
  return data;
};
